import { IsNotEmpty, IsBoolean, IsNumber, IsOptional, Min } from "class-validator";
import { AdapterTimeCardDto } from "../adapter-timecard.dto";

export class SapAdapterTimeCardDto extends AdapterTimeCardDto {
  @IsOptional()
  PersonNumber: string

  @IsOptional()
  PersonName: string

  @IsBoolean()
  is_final: boolean = false;

  @IsNotEmpty()
  @IsNumber()
  @Min(0, {
    message: (opts) =>
      `module.execution:validation.remaining_hours_validator?hours=${opts.constraints[0]}`,
  })
  remaining_hours: number = 0;
}
